import { useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload, faFile, faTrash, faDownload } from "@fortawesome/free-solid-svg-icons";
import styles from "./TableFileUpload.module.css";
import axios from "axios";
import {cdnUrl, sendFile} from "../../helper/http.ts";

interface TableFileUploadProps {
  value?: string | null;
  onChange: (file: File | null) => void;
  disabled?: boolean;
}

export default function TableFileUpload({ value, onChange, disabled = false }: TableFileUploadProps) {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;


    if (file) {
        sendFile(file).then((res) => {


            const copyFile = new File([], res.fileName, {type: file.type});


            onChange(copyFile);
        }).catch(console.error);
    }



  };

  const handleButtonClick = () => {
    inputRef.current?.click();
  };

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedFile(null);
    onChange(null);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const fileName = selectedFile?.name || (value ? value.split('/').pop() : null);
  const hasFile = fileName !== null;

  return (
    <div className={styles.tableFileUpload}>
      <input
        ref={inputRef}
        type="file"
        className={styles.hiddenInput}
        onChange={handleFileSelect}
        disabled={disabled}
      />

      {hasFile ? (
        <div className={styles.fileDisplay}>
          <div className={styles.fileInfo}>
            <FontAwesomeIcon icon={faFile} className={styles.fileIcon} />
            <span className={styles.fileName} title={fileName || ''}>
              {fileName && fileName.length > 15 ? fileName.substring(0, 15) + "..." : fileName}
            </span>
          </div>

          <div className={styles.actions}>
            {value && !selectedFile && (
                <a
                    href={cdnUrl + '/' + value}
                    download
                    className={styles.actionBtn}
                    onClick={(e) => e.stopPropagation()}
                    title="Download"
                    target='_blank'
                >
                    <FontAwesomeIcon icon={faDownload} />
                </a>
            )}

            <button
              type="button"
              onClick={handleRemove}
              className={styles.actionBtn}
              disabled={disabled}
              title="Remove"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        </div>
      ) : (
        <button
          type="button"
          onClick={handleButtonClick}
          className={styles.uploadButton}
          disabled={disabled}
        >
          <FontAwesomeIcon icon={faUpload} className={styles.uploadIcon} />
          <span>Upload</span>
        </button>
      )}
    </div>
  );
}